import session from '@/common/utils/session'
import { get } from 'lodash-es'

let NODE_ENV = process.env.NODE_ENV
let env = NODE_ENV

let { host } = window.location
// 当前host是pre环境
const inPre = host.indexOf('pre-') === 0
// 当前后端是否对应pre
const switchIsProd = session.getItem('isProd')
const isSimEnv = host.startsWith('sim')

/**
 * 由于我们没有切换pre构建的兼容写法
 */
if (isSimEnv) {
  env = 'sim'
} else if (inPre && !switchIsProd) {
  env = 'pre'
} else if (inPre) {
  env = 'production'
}
let apiConfig = {
  'development': {
    api: '//10.179.90.85:8300',
    gateway: '',
    bapi: 'http://sim342.rlab.sim.intra.xiaojukeji.com/b-api'
  },
  'test': {
    api: '//172.21.196.159:9999',
    gateway: '//10.96.98.128:9999',
    bapi: 'http://10.96.82.43:8066'
  },
  'pre': {
    api: '//pre-crm.didi-food.com',
    gateway: '//pre-dilu.didi-food.com',
    bapi: 'https://pre-b.didi-food.com'
  },
  'production': {
    api: '//crm.didi-food.com',
    gateway: '//dilu.didi-food.com',
    bapi: 'https://b.didi-food.com'
  },
  'sim': {
    // api: '//sim324.rlab.sim.intra.xiaojukeji.com',
    // gateway: 'http://sim324.rlab.sim.intra.xiaojukeji.com/dilu'
    api: '//' + host.replace('.bd', '') + '/crm',
    gateway: '//' + host.replace('.bd', '') + '/dilu',
    bapi: location.protocol + '//' + host.replace('.bd', '') + '/b-api'
  }
}

export default {
  hosts: get(apiConfig, env, apiConfig['production']),
  inPre,
  switchIsProd
}
